if (!customElements.get('promo-code-copy')) {
  customElements.define(
    'promo-code-copy',
    class PromoCodeCopy extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          box: this.querySelector('.promo-code-copy__box'),
          codeText: this.querySelector('[data-code-text]'),
          copiedText: this.querySelector('[data-copied-text]'),
        };

        this.promoCode = this.elements.box.dataset.promoCode;
        this.isAnimating = false;

        this.elements.box.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        if (this.isAnimating) return;

        this.copyToClipboard();
      } 

      copyToClipboard() {
        navigator.clipboard.writeText(this.promoCode).then(() => {
          this.showCopiedState();
        });
      }

      showCopiedState() {
        this.isAnimating = true;

        this.elements.codeText.classList.add('hidden');
        this.elements.copiedText.classList.remove('hidden');

        setTimeout(() => {
          this.resetState();
        }, 2000);
      }

      resetState() {
        this.elements.copiedText.classList.add('hidden');
        this.elements.codeText.classList.remove('hidden');

        setTimeout(() => {
          this.isAnimating = false;
        }, 200);
      }
    }
  );
}
